import React from 'react';
import { IconButton, Tooltip, Box } from '@mui/material';
import { motion } from 'framer-motion';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import { useThemeMode } from '../contexts/ThemeContext';

interface ThemeToggleProps {
  size?: 'small' | 'medium';
}

const ThemeToggle: React.FC<ThemeToggleProps> = ({ size = 'medium' }) => {
  const { mode, toggleTheme } = useThemeMode();
  const isDark = mode === 'dark';

  return (
    <Tooltip
      title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      arrow
      placement="bottom"
    >
      <IconButton
        onClick={toggleTheme}
        size={size}
        sx={{
          color: isDark ? '#FBBF24' : '#3B82F6',
          background: isDark
            ? 'rgba(251, 191, 36, 0.1)'
            : 'rgba(59, 130, 246, 0.1)',
          border: `1px solid ${isDark
            ? 'rgba(251, 191, 36, 0.2)'
            : 'rgba(59, 130, 246, 0.2)'}`,
          borderRadius: 2,
          p: size === 'small' ? 0.75 : 1,
          '&:hover': {
            background: isDark
              ? 'rgba(251, 191, 36, 0.2)'
              : 'rgba(59, 130, 246, 0.2)',
            transform: 'scale(1.05)',
          },
          transition: 'all 0.2s ease',
        }}
      >
        <Box
          component={motion.div}
          initial={false}
          animate={{ rotate: isDark ? 0 : 180 }}
          transition={{ duration: 0.3, ease: 'easeInOut' }}
          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          {isDark ? (
            <DarkModeIcon sx={{ fontSize: size === 'small' ? 18 : 22 }} />
          ) : (
            <LightModeIcon sx={{ fontSize: size === 'small' ? 18 : 22 }} />
          )}
        </Box>
      </IconButton>
    </Tooltip>
  );
};

export default ThemeToggle;
